module.exports = __webpack_public_path__ + "img/loading-97.2825e6e2.gif";